import { store } from 'store/index'
import { useCallback, useEffect } from 'react'
import { appVersionActions, appVersionSelectors } from 'store/app-version'
import { useAppVersion } from 'hooks/useAppVersion'
import { AppVersion } from 'types/app-version'
import { BUILD_TYPE } from 'config'
import { useTranslation } from 'react-i18next'
import { socketSingleton } from 'services/ws'
import { useSelector } from 'react-redux'

export const AppVersionBanner = () => {
  const { t } = useTranslation()
  const { reloadWindowAndClearServiceWorker, getLastPipelineVersion } = useAppVersion()
  const newUpdateAvailable = useSelector(appVersionSelectors.isUpdateAvailable)
  const lastPipelineVersion = useSelector(appVersionSelectors.lastPipelineVersion)

  const onVisibilityChange = useCallback(() => {
    if (!document.hidden) {
      getLastPipelineVersion().catch(console.error)
    }
  }, [])

  useEffect(() => {
    const onAppVersion = (message: { action: string; body: AppVersion }) => {
      const appVersion = message.body
      if (appVersion?.name === BUILD_TYPE) {
        store.dispatch(appVersionActions.setLastPipelineVersion(appVersion.version))
      }
    }

    getLastPipelineVersion().catch(console.error)
    socketSingleton.join('app-versions')
    socketSingleton.on('app_version_update', onAppVersion)

    document.addEventListener('visibilitychange', onVisibilityChange)

    return () => {
      socketSingleton.off('app_version_update', onAppVersion)
      socketSingleton.leave('app-versions')
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [])

  if (!newUpdateAvailable) {
    return null
  }

  return (
    <div className="tw-flex tw-flex-row">
      <div
        className="tw-text-xs tw-underline tw-cursor-pointer"
        onClick={reloadWindowAndClearServiceWorker}
        style={{ color: 'var(--text-primary)' }}
      >
        {t('versions.availableTitle')} ({lastPipelineVersion})
      </div>
    </div>
  )
}
